import React, { useEffect, useState } from 'react'
import './Login.css'
import { headers, url } from '../../utils/const'
import { useTranslation } from 'react-i18next';
function Login() { 
  const { t, i18n } = useTranslation();
    const legacyLogin = new URLSearchParams(window.location.search).get('loginBackground') === 'legacy'
        || process.env.REACT_APP_LOGIN_BACKGROUND === 'legacy';
    const [userName, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [level, setLevel] = useState('5')
    const [client, setClient] = useState('');
    const [point, setPoint] = useState('');
    const [code, setCode] = useState('');
    const [newPlayer, setNewPlayer] =useState(false)
    const [formAlert, setFormAlert] = useState(null)
    const [submitting, setSubmitting] = useState(false)

    /*  <ReactWhatsapp number="+18293338488" message="Hello World!!!"  value="What"/>*/

    useEffect(() => {
        if (localStorage.getItem('sessionId')) {
            if (localStorage.getItem('level') == '1' || localStorage.getItem('level') == '2') window.location.href = '/admin'
            if (localStorage.getItem('level') == '4') window.location.href = '/bet';
            if (localStorage.getItem('level') == '3') window.location.href = '/line';
            if (localStorage.getItem('level') == '5') window.location.href = "/admin-player";
        }

    }, [])
    /**detectar cambio en input */
    const ToChange = (e) => {
        if (e.target.name === 'userName') setUser(e.target.value)
        if (e.target.name === 'password') setPassword(e.target.value)
        if (e.target.name === 'level') setLevel(e.target.value)
        if (e.target.name === 'client') setClient(e.target.value)
        if (e.target.name === 'point') setPoint(e.target.value)
        if (e.target.name === 'code') setCode(e.target.value)    
    }

    /**Login */
    const validateNewPlayer = () => {
        const cleanPhone = phone.replace(/\D/g, '');
        if (userName.trim().length < 3) return 'Escriba el nombre completo del jugador.';
        if (!/^\d{10}$/.test(cleanPhone)) return 'El celular debe contener exactamente 10 dígitos.';
        if (password.length < 8 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) return 'La contraseña debe tener al menos 8 caracteres, una letra y un número.';
        if (!client.trim()) return 'Escriba el código del consorcio.';
        if (!point.trim()) return 'Escriba el código del punto de venta.';
        return null;
    }

    const ToLogin = async (event) => {
        event?.preventDefault();
        setFormAlert(null);
        if (level === '5' && newPlayer) {
            const validationError = validateNewPlayer();
            if (validationError) {
                setFormAlert({type:'danger', message:validationError});
                return;
            }
        } else if (!userName.trim() || !password) {
            setFormAlert({type:'danger', message:'Complete el usuario y la contraseña.'});
            return;
        }

        setSubmitting(true);
        let body = {}
        if(level ==='5' && newPlayer){
            const cleanPhone = phone.replace(/\D/g, '');
            body ={name: userName.trim(), username:cleanPhone, password, level, point:point.trim(), client:client.trim(), code, document: {type:'phone', number:cleanPhone}}
        } else{
            body ={ username:userName.trim(), password, level}
        }

        try {
            const res = await fetch(`${url}/login`, {
                method: 'post', headers, body: JSON.stringify(body)
            });
            const data = await res.json();
            if (res.ok && data && typeof data === 'object' && (data.user || data.code) && data.name && data.level) {
                localStorage.setItem('sessionId', data.sessionId); 
                localStorage.setItem('user', data.user || data.code);
                localStorage.setItem('name', data.name);
                localStorage.setItem('level', data.level);
                localStorage.setItem('point', data.point);
                localStorage.setItem('customer', data.company);
                if (localStorage.getItem('user') || localStorage.getItem('sessionId')) window.location.href = '/';
            } else {
                const message = typeof data === 'string' ? data : data?.message || data?.msg || 'No se pudo completar la operación.';
                setFormAlert({type:'danger', message});
            }
        } catch (error) {
            setFormAlert({type:'danger', message:'No fue posible conectar con el servidor. Verifique la conexión e intente nuevamente.'});
        } finally {
            setSubmitting(false);
        }
    }
    return (
        <div className={`container justify-content-center row ${legacyLogin ? 'dogs8-login-legacy' : 'dogs8-login-canodrome'}`}>

            <div className='row col-md-6 col-sm-12 col-xl-4 card justify-content-center'>
                <div className='card-header text-center' ><label className='etiquet'>Login</label></div>
                <form className='card-body justify-content-center' onSubmit={ToLogin} noValidate>
                    {formAlert && <div className={`alert alert-${formAlert.type}`} role="alert">{formAlert.message}</div>}
                    <div className='row col-12 justify-content-end p-0 m-0'>
                        <div className='col-sm-8 col-xl-4 col-md-4 p-0 m-0'><button type="button" className='btn btn-secondary form-control' onClick={()=> { setNewPlayer(value=> !value); setFormAlert(null); }} disabled={level !=='5'}>Registrar Nuevo Jugador</button></div>
                    </div>
                <div className='form-group col-sm-12 col-xl-8 com-md-4 row justify-content-center'>
                        <div className='col-12'><label>Seleccione el Rol</label></div>
                        <div className='col-12'><select className='form-select' name='level' value={level} onChange={ToChange}>
                            <option value="5" selected>{t('player')}</option>
                            <option value="4">Punto de Venta</option>
                            <option value="2">Consorcio o Grupo</option>
                            <option value="3">Soporte Tecnico</option>
                            <option value="1">Admin</option>
                            <option value="6">Agente</option>

                            
                        </select>
                        </div>
                    </div>
                    {level==='5' && newPlayer? <div className='col-12 row p-0 m-0 justify-content-center'>
                     <div className='form-group col-sm-12'>
                        <div className='col-12'><label>Nombre Jugador</label></div>
                        <div className='col-12'><input type="text" name='userName' className='form-control' value={userName} onChange={ToChange} /></div>
                    </div>
                    <div className='form-group col-12'>
                    <div className='col-12'><label>Celular</label></div>
                        <div className='col-12'><input type="tel" className='form-control' value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
                    </div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>Contraseña</label></div>
                        <div className='col-12'><input type="password" name='password' className='form-control' value={password || ''} onChange={ToChange} /></div>
                    </div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>Consorcio</label></div>
                        <div className='col-12'><input type="text" name='client' className='form-control' value={client} onChange={ToChange} /></div>
                    </div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>Punto de Venta</label></div>
                        <div className='col-12'><input type="text" name='point' className='form-control' value={point} onChange={ToChange} /></div>
                    </div>
                    <div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>Codigo</label></div>
                        <div className='col-12'><input type="text" name='code' placeholder='Escriba un Código de 4 Digitos' className='form-control' value={code} onChange={ToChange} /></div>
                    </div>                      
                    </div> 
                    </div>
                   
                    :<div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>{level==='5'? 'Celular':'Usuario'}</label></div>
                        <div className='col-12'><input type="text" name='userName' className='form-control' value={userName} onChange={ToChange} /></div>
                    </div>
                    <div className='form-group col-12'>
                        <div className='col-12'><label>Password</label></div>
                        <div className='col-12'><input type="password" name='password' className='form-control' value={password} onChange={ToChange} /></div>
                    </div>
                </div>}

                <div className=' row col-12 pt-3 pr-0 mr-0 justify-content-center'>
                    <div className='col-5 pr-0 mr-0'><button type="submit" className='btn btn-primary form-control' disabled={submitting}>{submitting ? 'Procesando...' : newPlayer && level === '5' ? 'Crear jugador' : 'Login'}</button></div>
                </div>
            </form>
            </div>
        </div>
    )
}

export default Login
